import React from 'react';
import styled from 'styled-components';
import theme from '../../../theme';
import yannick from './yannick.jpg';
import jacques from './jacques.png';
import william from './william.jpg';
import review5 from './stars-5.svg';
import './index.css';
import { formatPxToNumber } from '../../../utils';
import {APP_NAME} from '../../../constants';

const TEXT_WIDTH = formatPxToNumber(theme.cardWidth) - 20 * 2;

const Cards = styled.div`
  height: ${theme.cardHeight};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: ${theme.smallScreenCutoff}) {
    flex-direction: column;
    flex-wrap: wrap;
    height: 100%;
  }
`;

const Card = styled.div`
  height: 100%;
  text-align: center;
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${theme.smallScreenCutoff}) {
    margin: 20px 0;
  }
`;

const UserImage = styled.div`
 
  background-image: url(${props => props.src});
  
  /* make a square container */
  height: 100px;
  width: 100px;
  
  /* fill the container, preserving aspect ratio, and cropping to fit */
  background-size: cover;

  /* center the image vertically and horizontally */
  background-position: center;

  /* round the edges to a circle with border radius 1/2 container size */
  border-radius: 50%;
`;

const RatingImage = styled.div`
  background-image: url(${props => props.src});
  
  /* make a square container */
  height: 50px;
  width: 100px;
  
  /* fill the container, preserving aspect ratio, and cropping to fit */
  background-size: 100% 100%;

  /* center the image vertically and horizontally */
  background-position: center;

  /* round the edges to a circle with border radius 1/2 container size */
  border-radius: 50%;
`;


const CardText = styled.div`
  flex-grow: 1;
  width: ${TEXT_WIDTH}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;



function SocialProof() {
  return (
    <div className="full-width">
      <Cards>
        <Card className="pt-card pt-elevation-2">
          <UserImage src={jacques}/>
          <div className="horizontal-divider"/>
          <RatingImage src={review5}/>
          <CardText>
            <div className="quote">
              I turn on the subtitles when I’m
              screensharing with my team in Japan so
              they can follow along more easily. It’s perfect!
            </div>
            <div className="horizontal-divider"/>
            <div className="quote-from">
              Jacques, Head of Product @ Renault
            </div>
          </CardText>
        </Card>
        <Card className="pt-card pt-elevation-2">
          <UserImage src={william}/>
          <div className="horizontal-divider"/>
          <RatingImage src={review5}/>
          <CardText>
            <div className="quote">
              I love the app! Having French and English subtitles while
              watching French TED talks is really
              helping me pick up new words.
            </div>
            <div className="horizontal-divider"/>
            <div className="quote-from">
              William, French Student
            </div>
          </CardText>
        </Card>
        <Card className="pt-card pt-elevation-2">
          <UserImage src={yannick}/>
          <div className="horizontal-divider"/>
          <RatingImage src={review5}/>
          <CardText>
            <div className="quote">
              {APP_NAME} has been great for
              understanding English-speaking
              conference talks.
            </div>
            <div className="horizontal-divider"/>
            <div className="quote-from">
              Yannick, Director @ NeuroTechX
            </div>
          </CardText>
        </Card>
      </Cards>
    </div>
  )
}

export default SocialProof;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/SocialProof/index.js